<template>
    <div>
        <span v-if="this.data !== ''">
            {{this.data}}
        </span>
        <em v-else>
            空
        </em>
    </div>
</template>

<script>
	export default {
		name: "StaticLabel",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return this.data;
			}
		}
	}
</script>

<style scoped>

</style>